module.exports = __webpack_public_path__ + "d8f19372521c673130e521a49206edd4.png";